import React from "react"
import { Alert, AlertProps } from "@blueprintjs/core"
import classNames from "utils/classNames"

interface CustomAlertProps extends AlertProps {
  light?: boolean
  children?: React.ReactNode
}
const CustomAlert = ({
  children,
  light,
  className,
  ...otherProps
}: CustomAlertProps) => {
  return (
    <Alert
      className={classNames(
        "vt-custom-alert",
        {
          "vt-custom-alert-light": light,
        },
        className
      )}
      {...otherProps}
    >
      {children}
    </Alert>
  )
}

export default CustomAlert
